import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const AdBlockChecker = () => {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    // Local storage'dan kontrol et
    const hasSeenWarning = localStorage.getItem('adBlockWarningDismissed');
    if (!hasSeenWarning) {
      setShowWarning(true);
    }
  }, []);

  const handleDismiss = () => {
    // Local storage'a kaydet
    localStorage.setItem('adBlockWarningDismissed', 'true');
    setShowWarning(false);
  };

  // Uyarı gösterilmeyecekse null dön
  if (!showWarning) return null;

  return (
    <Box
      style={{
        backgroundColor: '#d32f2f',
        color: 'white',
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '20px',
        borderRadius: '10px',
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          maxWidth: '1200px',
          width: '100%',
          position: 'relative',
          padding: '0 48px',
        }}
      >
        <Typography variant="body1" style={{ textAlign: 'center', flex: 1 }}>
          Raporları daha iyi görüntüleyebilmek için lütfen reklam engelleyiciniz varsa devre dışı bırakın.
        </Typography>
        <IconButton
          onClick={handleDismiss}
          style={{
            position: 'absolute',
            right: 0,
            color: 'white',
            padding: '8px',
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default AdBlockChecker; 